<template>
    <div class="electrictiy-bill-calculator__result">
       <h3 class="electrictiy-bill-calculator__result-heading">{{appSettings.Result.Title}}</h3>
       <div class="article-border"></div>
       <div class="electrictiy-bill-calculator__form-intro-container">
            <div class="electrictiy-bill-calculator__form-preamble" v-if="appSettings.Result.Ingress" v-html="appSettings.Result.Ingress">
            </div>

            <read-more v-if="appSettings.Result.ReadMoreText" :button-text="appSettings.Result.ReadMoreButtonText" element-id="read-more-step-1">
                <p v-html="appSettings.Result.ReadMoreText">
                </p>
            </read-more>                
        </div>

       <div aria-hidden="true">
            <div class="electrictiy-bill-calculator__result-charts-button-group" aria-label="Växla vy mellan år och månad">
                <button class="electrictiy-bill-calculator__result-charts-button-item action-button" :class="showYearChart ? 'button-item-active' :''" type="button" :aria-pressed="showYearChart" title="År" @click="showYearChart = true" aria-label="År">
                    År
                </button>
                <button class="electrictiy-bill-calculator__result-charts-button-item action-button" :class="!showYearChart ? 'button-item-active' :''" type="button" :aria-pressed="!showYearChart"  title="Månad" @click="showYearChart = false" aria-label="Månad">
                    Månad
                </button>
            </div>
        </div>

        <div class="switch-wrapper">
            <label>
                <span class="label" for="includevat" id="includevatlabel">
                    <span v-if="includeVat" role="alert">Visar inklusive moms</span>
                    <span v-else role="alert">Visar exklusive moms</span>
                </span>
                <input id="includevat" type="checkbox" :aria-checked="includeVat" role="switch" v-model="includeVat" @change="toggleIncludeVat" aria-controls="resultTable">
                <span class="state" aria-hidden="true">
                    <span class="container">
                        <span class="position">
                        </span>
                    </span> 
                    <span class="on"></span>
                    <span class="off"></span>
                </span>
            </label>
        </div>     
  
        <div class="electrictiy-bill-calculator__result-chart-and-table-container" :class="showYearChart ? 'electrictiy-bill-calculator__result-chart-and-table-container--side-by-side' :''" aria-hidden="true">
            <div>
                <div>
                    <div v-show="showYearChart">
                        <result-year-chart ref="yearChartElement" :colors="colors"></result-year-chart>
                    </div>
                    <div v-show="!showYearChart">
                        <result-month-chart ref="monthChartElement" :colors="colors"></result-month-chart>
                    </div>
                </div>

                <result-table :colors="colors"></result-table>
            </div>
        </div>

	</div>
</template>


<script setup>
    import ReadMore from './ReadMore.vue';
    import ResultTable from './ResultTable.vue';
    import ResultMonthChart from './ResultMonthChart.vue';
    import ResultYearChart from './ResultYearChart.vue';
    import { CustomerTypeEnum } from '../Enums';
    import { useWizardStore } from '../stores/WizardStore';
    import { storeToRefs } from "pinia";
    import { ref, nextTick, onMounted, watch } from 'vue'
    
    const store = useWizardStore()
    const { appSettings, calculatedPrice, includeVat, customerType } = storeToRefs(store);

    const showYearChart = ref(true);
    const yearChartElement = ref();
    const monthChartElement = ref();    
    let updateChartTypeNextTime = false;

    const colors = {
        TransferCost:  {backgroundColor:'#195D64', textColor: '#FFF'},
        FixedCharge:   {backgroundColor:'#E5D59C', textColor: '#000'},
        EffectCost:    {backgroundColor:'#9FBFC2', textColor: '#000'},
        EnergyTaxCost: {backgroundColor:'#575756', textColor: '#FFF'}
    };    

    
    const initChart = () => {
        setChartTypeBasedOnCustomerType();
        if(showYearChart.value) {
            nextTick(() => {                
                yearChartElement.value.initYearChart();
            });
        } else {
            nextTick(() => {
                monthChartElement.value.initMonthChart();
            });            
        }
     }

    const updateChart = () => {
        if(updateChartTypeNextTime) {
            setChartTypeBasedOnCustomerType();
            updateChartTypeNextTime = false;
        }
        nextTick(() => {           
            if(showYearChart.value) {                    
                yearChartElement.value.updateChart();
            }
            else {
                monthChartElement.value.updateChart();
            }
        });   
     }

    const setChartTypeBasedOnCustomerType = () => {
        showYearChart.value = customerType.value === CustomerTypeEnum.COMPANY;
    } 

    //Change chart type
    watch(showYearChart, () => {    
        updateChart();
     })   

    //Change chart type
    watch(customerType, () => {    
        updateChartTypeNextTime = true;
     })   

    //Update chart when calculated price is updated in the state
    watch(calculatedPrice, () => {    
        updateChart();
     }, {deep: true})    

    //Toggle vat on or off
    const toggleIncludeVat = () => {
        store.calculateNewPrice();
    }

    onMounted(() => {  
        //store.calculateNewPrice();  
        initChart();
    })

   
</script>

<style scoped>
</style>
